const dateDay =  [
    {
      title: "上午",
      key: "am",
    },
    {
      title: "下午",
      key: "pm",
    },
  ];

const formTitle = function(item,formSet) {
   
    var title = "";
    if (formSet.titleSet && formSet.titleSet.titleItems) {
        var model = Object.assign({}, item)
        if (formSet.titleSet.titleItems.indexOf("creator") != -1) {
            title += `${model.creator}提交`
        }
        if (formSet.titleSet.titleItems.indexOf("title") != -1) {
            title += `${model.title}`
        }

        model.formList.forEach(a => {
            var info = formSet.titleSet.titleItems.filter(x => {
                return (a.set.setId && a.set.setId == x);
            })

            if (info != null && info.length > 0) {

                var title2 = a.set.value;
                if (a.set.control == "class_stu") {
                    var value = JSON.parse(a.set.value);
                    title2 = value.title
                } else if (a.set.control == "user_baseinfo") {
                    var value = JSON.parse(a.set.value);
                    title2 = value.name
                    if (value.type == 'student') {
                        title2 += `/${value.className}`
                    }
                } else if (a.set.control == 'school_week') {
                    var value = JSON.parse(a.set.value);
                    title2 = value.title
                } else {
                    title2 = JSON.parse(a.set.value);
                }
                title += title2
            }
        })
    } else {
        var model = Object.assign({}, item)
        title += `${model.creator}提交`
        title += `${model.title}`
    }

    console.log(`title:${title}`);
    return title;
}

const formContent = function(item,formSet) {
   
    var list = [];
    if (formSet.titleSet && formSet.titleSet.type == "custom") {

        var model = Object.assign({}, item)

        console.log(`model:${JSON.stringify(model.formList)}`)

        model.formList.forEach(a => {
            var info = formSet.titleSet.formItems.filter(x => {
                return (a.set.setId && a.set.setId == x);
            })

            if (info != null && info.length > 0) {
                var push = true;
                var title2 = a.set.value;
                if(a.set.control == 'hq_wz') {
                    var value = JSON.parse(a.set.value);
                    var title = "";
                    
                    value.forEach(a => {
                        list.push({
                            title: "物品",
                            content: `${a.title},申请数量：${a.count}\n`,
                            type: 'text'
                        })
                    })
                    // title2 = title;
                    push = false;
            
                  }else  if (a.set.control == "class_stu") {
                    var value = JSON.parse(a.set.value);
                    title2 = value.title
                } else if (a.set.control == "user_baseinfo") {
                    var value = JSON.parse(a.set.value);
                    title2 = value.name
                    if (value.type == 'student') {
                        title2 += `/${value.className}`
                    }
                } else if (a.set.control == 'school_week') {
                    var value = JSON.parse(a.set.value);
                    title2 = value.title
                } else if (a.set.control == "datepicker" && a.set.type == 'range') {
                    var value = JSON.parse(a.set.value);
                    if(a.set.isTil) {
                        list.push(`${a.set.title}：${a.set.start} ${dateDay[a.set.startIndex].title}`)
                        list.push(`${a.set.title2}：${a.set.end} ${dateDay[a.set.endIndex].title}`)
                    }else {
                        list.push(`${a.set.title}：${a.set.start}`)
                        list.push(`${a.set.title2}：${a.set.end}`)
                    }
                    
                    var unit = "（小时）";
                    if (a.set.unit == "date") {
                        unit = "（天）"
                    }
                    if (a.set.isDuration) {
                        list.push(`${a.set.timeLongTitle}：${value}${unit}`)
                    }
                    
                    
                    push = false;
                }
                else {
                    title2 = JSON.parse(a.set.value);
                }


                if(push) {
                    list.push(`${a.set.title}：${title2}`)
                }
            }
        })
    }
    return list;
}

const formStatus = function(status, action) {
    var icon = "";
    if (status == 0) {
        switch (action) {
            case 1:
                icon = "待审核"
                break;
            case 4:
                icon = "待办理"
                break;
            default:
                icon = "已完成"
                break;
        }
    } else {
        switch (action) {
            case 2:
                icon = "已通过"
                break;
            case 3:
                icon = "已拒绝"
                break;
            case 6:
                icon = "已拒绝"
                break;
            default:
                icon = "已完成"
                break;
        }
    }
    return icon;

}

const formStatusType = function(status, action) {
    var type = "";
    if (status == 0) {
        switch (action) {
            case 1:
                type = "warning"
                break;
            case 4:
                type = "warning"
                break;
            default:
                type = "success"
                break;
        }
    } else {
        switch (action) {
            case 2:
                type = "success"
                break;
            case 3:
                type = "error"
                break;
            case 6:
                type = "error"
                break;
            default:
                type = "success"
                break;
        }
    }
    return type;

}

const dateFormatter = function(time) {
    time = time.replace(/-/g, '/');

    var timestamp = new Date(time).getTime();

    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var halfamonth = day * 15;
    var month = day * 30;
    var year = day * 365;
    var now = new Date().getTime();
    var diffValue = now - timestamp;
    var result;
    if (diffValue < 0) {
        return;
    }
    var yearC = diffValue / year;
    var monthC = diffValue / month;
    var weekC = diffValue / (7 * day);
    var dayC = diffValue / day;
    var hourC = diffValue / hour;
    var minC = diffValue / minute;
    if (yearC >= 1) {
        result = dateFtt(time, 'yyyy-MM-dd hh:mm')
    } else if (monthC >= 1) {
        result = dateFtt(time, 'yyyy-MM-dd hh:mm')
    } else if (weekC >= 1) {
        result = dateFtt(time, 'yyyy-MM-dd hh:mm')
    } else if (dayC >= 1) {
        result = dateFtt(time, 'yyyy-MM-dd hh:mm')
    } else if (hourC >= 1) {
        result = dateFtt(time, 'yyyy-MM-dd hh:mm')
    } else if (minC >= 1) {
        result = "" + parseInt(minC) + "分钟前";
    } else
        result = "刚刚";
    return result;
}

function dateFtt(time, fmt) { //author: meizz 
    var date = new Date(time)
    var o = {
        "M+": date.getMonth() + 1, //月份 
        "d+": date.getDate(), //日 
        "h+": date.getHours(), //小时 
        "m+": date.getMinutes(), //分 
        "s+": date.getSeconds(), //秒 
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
        "S": date.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
                .length)));
    return fmt;
}

module.exports = {
	formTitle,
    formContent,
    formStatus,
    formStatusType,
    dateFormatter
}
